import styled from 'styled-components';

export const StatusSelect = styled.select`
  width: 100%;
  max-width: 400px;
  padding: 10px 12px;
  font-size: 1rem;
  border: 1px solid #555;
  border-radius: 6px;
  background-color: #2e2e2e;
  color: #e0e0e0;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4a9eff;
    box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
  }

  &:hover {
    border-color: #666;
  }

  option {
    background-color: #2e2e2e;
    color: #e0e0e0;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const InstallmentCheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px 12px;
  border: 1px solid #555;
  border-radius: 6px;
  background-color: #2a2a2a;
  max-width: 400px;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: #666;
    background-color: #333;
  }

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    accent-color: #4a9eff;
    cursor: pointer;
  }

  span {
    font-size: 1rem;
    color: #e0e0e0;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const BillDateInput = styled.input.attrs({ type: 'date' })`
  width: 100%;
  max-width: 400px;
  padding: 10px 12px;
  font-size: 1rem;
  border: 1px solid #555;
  border-radius: 6px;
  background-color: #2e2e2e;
  color: #e0e0e0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4a9eff;
    box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
  }

  &:hover {
    border-color: #666;
  }

  &::-webkit-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const BillNumberInput = styled.input.attrs({ type: 'number' })`
  width: 100%;
  max-width: 400px;
  padding: 10px 12px;
  font-size: 1rem;
  border: 1px solid #555;
  border-radius: 6px;
  background-color: #2e2e2e;
  color: #e0e0e0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    opacity: 1;
  }

  &:focus {
    outline: none;
    border-color: #4a9eff;
    box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
  }

  &:hover {
    border-color: #666;
  }

  &::placeholder {
    color: #888;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const InstallmentSection = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #555;
  border-radius: 8px;
  background-color: #2a2a2a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

export const InstallmentSectionLabel = styled.span`
  font-size: 0.875rem;
  color: #a0a0a0;
  display: block;
  margin-bottom: 0.75rem;
`;

export const HelperText = styled.span`
  font-size: 0.8rem;
  color: #888;
  display: block;
  margin-top: 4px;
`;
